import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import {
  HubtypeApiService,
  PaginatedResults,
} from '../../../services/hubtype-api/hubtype-api.service'
import { TimezoneService } from '../../../services/timezone.service'
import {
  CopilotConversationDetail,
  CopilotConversationListItem,
  CopilotQueryResponse,
  CopilotResultResponse,
} from '../models/copilot.model'

const BASE = '/analytics/copilot'

@Injectable({ providedIn: 'root' })
export class CopilotService {
  readonly #api = inject(HubtypeApiService)
  readonly #timezone = inject(TimezoneService)

  createConversation(): Observable<CopilotConversationListItem> {
    return this.#api.post(`${BASE}/conversations/`, {}, undefined, 'v1', false)
  }

  createUserQuery(
    conversationId: string,
    question: string
  ): Observable<CopilotQueryResponse> {
    return this.#api.post(
      `${BASE}/conversations/${conversationId}/user_query/`,
      { question, timezone: this.#timezone.timezone() },
      undefined,
      'v1',
      false
    )
  }

  listConversations(): Observable<CopilotConversationListItem[]> {
    return this.#api
      .get(`${BASE}/conversations/`, undefined, 'v1', false)
      .pipe(
        map((res: PaginatedResults<CopilotConversationListItem>) => res.results)
      )
  }

  getConversation(id: string): Observable<CopilotConversationDetail> {
    return this.#api.get(`${BASE}/conversations/${id}/`, undefined, 'v1', false)
  }

  updateConversation(
    id: string,
    patch: { title?: string; is_pinned?: boolean }
  ): Observable<void> {
    return this.#api.patch(`${BASE}/conversations/${id}/`, patch, 'v1', false)
  }

  deleteConversation(id: string): Observable<void> {
    return this.#api.delete(
      `${BASE}/conversations/${id}/`,
      undefined,
      undefined,
      'v1',
      false
    )
  }

  getMessageResult(
    conversationId: string,
    messageId: string
  ): Observable<CopilotResultResponse> {
    return this.#api.get(
      `${BASE}/conversations/${conversationId}/user_query/${messageId}/result/`,
      undefined,
      'v1',
      false
    )
  }
}
